//
import EmployeeModel from '@/models/HumanResource/HrEmployee'
import HealthAffiliationModel from '@/models/HumanResource/HrHealthAffiliation'
import PrevisionModel from '@/models/HumanResource/HrPrevision'

//
export default [
    {
        name    : 'hr_employee_id',
        type    : 'autocomplete-model',
        props   : {
            hideDetails : true,
            itemText    : ({ names, last_name1, last_name2 }) => [ names, last_name1, last_name2 ].join( ' ' ),
            itemValue   : 'id',
            label       : 'Empleado',
            model       : EmployeeModel,
            noObject    : true,
            paramSearch : 'names',
        },
    },
    {
        name    : 'hr_prevision_id',
        type    : 'autocomplete-model',
        props   : {
            hideDetails : true,
            itemText    : 'name',
            itemValue   : 'id',
            label       : 'Prevision',
            model       : PrevisionModel,
            noObject    : true,
            paramSearch : 'name',
        },
    },
    {
        name    : 'hr_health_affiliation_id',
        type    : 'autocomplete-model',
        props   : {
            hideDetails : true,
            itemText    : 'name',
            itemValue   : 'id',
            label       : 'Afiliación de salud',
            model       : HealthAffiliationModel,
            noObject    : true,
            paramSearch : 'name',
        },
    },
]